import { memo } from 'react';

import BasicBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/BasicBtn';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  /** msg */
  msg?: string | React.ReactNode;
  /** btnText */
  btnText?: string;
  /** className */
  className?: string;
  /** onClick */
  onClick?: () => void;
}

const EmptyBox = ({ msg = '', btnText = '', className, onClick }: IProps) => (
  <S.EmptyBox className={classNameBind(['empty-box', className || ''])}>
    <Text paragraph className="msg">
      {msg}
    </Text>
    {onClick && <BasicBtn text={btnText} onClick={onClick} />}
  </S.EmptyBox>
);

export default memo(EmptyBox);
